export interface StorageAdapter {
    readSession(key: string): string | null;
    writeSession(key: string, value: string | null): boolean;
    readLocal(key: string): string | null;
    writeLocal(key: string, value: string | null): boolean;
}

export function createMemoryStorageAdapter(): StorageAdapter {
    const localStorage = new Map<string, string>();
    const sessionStorage = new Map<string, string>();
    const read = (storage: Map<string, string>, key: string): string | null => {
        const value = storage.get(key);
        return (value !== undefined ? value : null);
    };
    const write = (
        storage: Map<string, string>,
        key: string,
        value: string | null,
    ): boolean => {
        if (value !== null) {
            storage.set(key, value);
        } else {
            storage.delete(key);
        }
        return true;
    };
    return {
        readSession(key: string): string | null {
            return read(sessionStorage, key);
        },
        writeSession(key: string, value: string | null): boolean {
            return write(sessionStorage, key, value);
        },
        readLocal(key: string): string | null {
            return read(localStorage, key);
        },
        writeLocal(key: string, value: string | null): boolean {
            return write(localStorage, key, value);
        },
    };
}
